import React from 'react';
import PropTypes from 'prop-types';

import '../styles/components/no-items.scss';

export function NoItems({ title }) {
    return (
        <div className="no-items-container">
            <span>{title}</span>
        </div>
    );
}

NoItems.propTypes = {
    title: PropTypes.string.isRequired
};
